import { FC } from 'react';
import styled, { AnyStyledComponent } from 'styled-components';
import {
  PopoverArrowProps,
  PopperWrapperProps,
  ReferenceWrapperProps,
  PopperContainerProps,
} from './popover.types';
import COLORS from '../../style/universal.color';
import { MLBTheme } from '../../style/theme.types';

const zIndex = 999999;

export const PopoverArrow: FC<PopoverArrowProps> = styled.div`
  position: absolute;
  font-size: 7px;
  ${({ popperPosition, theme= {}, arrowStyles }: PopoverArrowProps) => {
    const transformStyle = arrowStyles?.transform;
    const transformX = parseInt(transformStyle?.slice(transformStyle?.indexOf('(')+1, transformStyle?.indexOf('px')) || '', 10);
    const transformY = parseInt(transformStyle?.slice(transformStyle?.indexOf(',')+1, transformStyle?.lastIndexOf('px')) || '', 10);

    switch(popperPosition) {
      case 'bottom':
      case 'bottom-start':
      case 'bottom-end':
        return `
          top: 0px;
          left: 0px;
          transform: translate(${transformX}px, ${transformY}px);
          &:before {
            content: '';
            position: absolute;
            top: 0px;
            left: -7px;
            border-left: 1em solid transparent;
            border-right: 1em solid transparent;
            border-bottom: 1em solid ${theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey1};
            margin-top: -1em;
          }
          &:after {
            content: '';
            position: absolute;
            top: -6px;
            left: -7px;
            border-left: 1em solid ${COLORS.transparent};
            border-right: 1em solid ${COLORS.transparent};
            border-bottom: 1em solid ${theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1};
          }
      `;
      case 'top':
      case 'top-start':
      case 'top-end':
        return `
          bottom: 0px;
          left: 0px;
          transform: translate(${transformX}px, ${transformY}px);
          &:before {
            content: '';
            position: absolute;
            bottom: 0px;
            left: -7px;
            border-left: 1em solid ${COLORS.transparent};
            border-right: 1em solid ${COLORS.transparent};
            border-top: 1em solid ${theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey1};
            margin-bottom: -1em;
          }
          &:after {
            content: '';
            position: absolute;
            bottom: -6px;
            left: -7px;
            border-left: 1em solid ${COLORS.transparent};
            border-right: 1em solid ${COLORS.transparent};
            border-top: 1em solid ${theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1};
          }
        `;
      case 'left':
      case 'left-start':
      case 'left-end':
        return `
          top: 0px;
          right: 0px;
          transform: translate(${transformX}px, ${transformY}px);
          &:before {
            content: '';
            position: absolute;
            top: -7px;
            right: 0px;
            border-top: 1em solid ${COLORS.transparent};
            border-bottom: 1em solid ${COLORS.transparent};
            border-left: 1em solid ${theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey1};
            margin-right: -1em;
          }
          &:after {
            content: '';
            position: absolute;
            top: -7px;
            right: -6px;
            border-top: 1em solid ${COLORS.transparent};
            border-bottom: 1em solid ${COLORS.transparent};
            border-left: 1em solid ${theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1};
          }
        `;
      case 'right':
      case 'right-start':
      case 'right-end':
        return `
          left: 0px;
          top: 0px;
          transform: translate(${transformX}px, ${transformY}px);
          &:before {
            content: '';
            position: absolute;
            left: 0px;
            top: -7px;
            border-top: 1em solid ${COLORS.transparent};
            border-bottom: 1em solid ${COLORS.transparent};
            border-right: 1em solid ${theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey1};
            margin-left: -1em;
          }
          &:after {
            content: '';
            position: absolute;
            top: -7px;
            left: -6px;
            border-top: 1em solid ${COLORS.transparent};
            border-bottom: 1em solid ${COLORS.transparent};
            border-right: 1em solid ${theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1};
          }
        `;
      default:
        return '';
    }
  }}
`;

export const PopperWrapper: AnyStyledComponent = styled.div<PopperWrapperProps>`
  box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2);
  border: solid 1px ${({ theme }: { theme: MLBTheme }) => theme.dark ? COLORS.mlbGrey6 : COLORS.mlbGrey1};
  background-color: ${({ theme }: { theme: MLBTheme }) => theme.dark ? COLORS.mlbGrey7 : COLORS.mlbGrey1};
  border-radius: 6px;
`;

export const ReferenceWrapper: FC<ReferenceWrapperProps> = styled.span`
  display: inline-block;
  ${({ isShowingBackdrop }: ReferenceWrapperProps) => isShowingBackdrop && `z-index: ${zIndex + 1};`};
`;

export const PopperContainer = styled.div`
  ${({ isShowingBackdrop }: PopperContainerProps) => isShowingBackdrop && `z-index: ${zIndex};`};
`;
